module.exports = __webpack_public_path__ + "img/trial2-3.6947a5c8.png";